// SharedConfig.ts

export const CONFIG = {
    SAMPLE_RATE: 48000,
    CHANNELS: 2, // Stereo
    BUFFER_SECONDS: 3, // 3 secondi di buffer circolare (sicurezza contro glitch)

    // Stamp granularity (in samples) used to mark which parts of the audio ring-buffer
    // contain valid data for the current playback epoch.
    //
    // IMPORTANT: should be a multiple of the AudioWorklet render quantum (128) to keep
    // stamping simple and cheap.
    STAMP_BLOCK_SIZE: 128,
};

// Calcoliamo la lunghezza in campioni di un singolo canale nel buffer
export const CHANNEL_LENGTH = CONFIG.SAMPLE_RATE * CONFIG.BUFFER_SECONDS;

// One stamp per STAMP_BLOCK_SIZE samples (per channel).
// CHANNEL_LENGTH should be divisible by STAMP_BLOCK_SIZE; if it isn't, we round up.
export const STAMP_LENGTH = Math.ceil(CHANNEL_LENGTH / CONFIG.STAMP_BLOCK_SIZE);

// Mappa della memoria (Header iniziale contiene lo stato in Int32)
export const MEM_MAP = {
    // Indici nell'Int32Array (Stato)
    WRITE_PTR: 0, // Dove scrive il Worker (Indice array)  (debug/compat)
    READ_PTR: 1, // Dove legge la Worklet (Indice array)   (debug/compat)
    MASTER_CLOCK: 2, // Totale campioni riprodotti (Atomic Counter)
    IS_PLAYING: 3, // 0 = Pause, 1 = Play

    // Increments on seek/reset to invalidate old stamped blocks.
    AUDIO_EPOCH: 4,

    // Absolute-sample cursor representing the next sample that should be considered
    // "validly buffered" by the producer. This is used by the worker to decide how
    // far ahead audio has been produced, and it is independent from READ/WRITE_PTR.
    AUDIO_VALID_UNTIL: 5,

    // Header size (bytes) for stateView.
    // Keep this derived from the number of Int32 slots to avoid manual mismatches.
    HEADER_INTS: 6,
    HEADER_SIZE: 6 * Int32Array.BYTES_PER_ELEMENT,
};

export function createSharedBuffer() {
    const stateBytes = MEM_MAP.HEADER_SIZE;

    // Spazio per 2 canali * lunghezza * 4 byte (float32)
    const audioBytes =
        CONFIG.CHANNELS * CHANNEL_LENGTH * Float32Array.BYTES_PER_ELEMENT;

    // Stamp buffer (Int32) used by the AudioWorklet to decide whether a block contains
    // valid data for the current AUDIO_EPOCH.
    const stampBytes = STAMP_LENGTH * Int32Array.BYTES_PER_ELEMENT;

    return new SharedArrayBuffer(stateBytes + audioBytes + stampBytes);
}

// Helper per ottenere le viste tipizzate dal buffer grezzo
export function getMemoryViews(sab: SharedArrayBuffer) {
    const stateView = new Int32Array(sab, 0, MEM_MAP.HEADER_INTS);

    const leftOffset = MEM_MAP.HEADER_SIZE;
    const rightOffset =
        MEM_MAP.HEADER_SIZE + CHANNEL_LENGTH * Float32Array.BYTES_PER_ELEMENT;

    const stampOffset =
        MEM_MAP.HEADER_SIZE +
        CONFIG.CHANNELS * CHANNEL_LENGTH * Float32Array.BYTES_PER_ELEMENT;

    const leftView = new Float32Array(sab, leftOffset, CHANNEL_LENGTH);
    const rightView = new Float32Array(sab, rightOffset, CHANNEL_LENGTH);

    const stampView = new Int32Array(sab, stampOffset, STAMP_LENGTH);

    return { stateView, leftView, rightView, stampView };
}